export default __webpack_public_path__ + "static/media/ico-palette.8a2f53e8.svg";